export const SNAP_SCROLL_OFFSET = 100;
